import httpClient from '@/api/http-client';
import getFormData from '@/util/form-data';

const endpoint = 'api/driving-permits';

const getDrivingPermitFormData = (drivingPermit) => {
  const fieldBlacklist = ['subject', 'user'];

  if (drivingPermit.applicant_user_id) {
    fieldBlacklist.push('applicant_user');
  }

  const formData = getFormData(drivingPermit, fieldBlacklist);
  if (!drivingPermit.new_documents?.length) {
    // to receive document validation messages, when there's no files selected
    formData.append('new_documents[]', '');
  }
  return formData;
};

const drivingPermitService = {
  getPage: (params) => httpClient.get(endpoint, { params }),

  getById: (id) => httpClient.get(`${endpoint}/${id}`),

  search: (query) => httpClient.get(`${endpoint}/find/${query}`),

  create: (drivingPermit) => {
    const formData = getDrivingPermitFormData(drivingPermit);
    return httpClient.post(`${endpoint}`, formData);
  },

  update: (drivingPermit) => {
    const formData = getDrivingPermitFormData(drivingPermit);
    formData.append('_method', 'put');
    return httpClient.post(`${endpoint}/${drivingPermit.id}`, formData);
  },

  delete: (drivingPermit) => httpClient.delete(`${endpoint}/${drivingPermit.id}`),

  getPassedExamCount: () => httpClient.get('api/total-driving-permits-with-passed-exams'),

  changeIssuedStatus: (payload) =>
    httpClient.post(`${endpoint}/${payload.id}/issued-permit-status`, payload),

  getReport: (params) => httpClient.get('api/driving-permit-report', { params }),

  downloadReportXlsx: (params) =>
    httpClient({
      url: 'api/driving-permit-report-download',
      method: 'GET',
      responseType: 'blob',
      params,
    }),

  updateEndAt: (payload) =>
    httpClient.patch(`${endpoint}/${payload.permit_id}/end-at`, { end_at: payload.end_at }),

  getXlsx: (ids) =>
    httpClient({
      url: 'api/driving-permits-xlsx',
      method: 'GET',
      responseType: 'blob',
      params: { driving_permit_ids: ids },
    }),
};

export default drivingPermitService;
